import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungSaarbruecken() {
  return (
    <CityPageTemplate
      city="Saarbrücken"
      slug="saarbruecken"
      intro="In der Landeshauptstadt des Saarlandes setzen wir auf unabhängige Beratung ohne Bankbindung."
      description="Unabhängige & digitale Finanzberatung für Saarbrücken: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
